import { getMeta } from '@helpcenter/meta';
import { createRelayResource } from '@atlassian/help-center-common-util/resource-router';
import { PAGINATION_SIZE } from '../../common/constants';
import CsmRequestsListQuery, {
	type csmRequestsListQuery,
} from '../../ui/__generated__/csmRequestsListQuery.graphql';

export const csmRequestsListQueryResource = createRelayResource<csmRequestsListQuery>({
	type: 'CSM_REQUESTS_LIST_QUERY',
	getQuery: (_, { cloudId }) => ({
		parameters: CsmRequestsListQuery,
		variables: {
			cloudId,
			accountId: getMeta('account-id') ?? '',
			helpCenterId: getMeta('help-center-ari') ?? '',
			count: PAGINATION_SIZE,
		},
		options: {
			fetchPolicy: 'store-or-network',
		},
	}),
});
